import { ReactNode, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import Heading from '@alltrails/denali/components/Heading';
import Logo from '@alltrails/denali/components/Logo';
import { ModalAriaLabelledByContext } from '@alltrails/modal/components/Modal/ModalAriaLabelledByContext';
import LoginResponse from '../../types/LoginResponse';
import RegisterForm from '../RegisterForm';
import TermsOfService from '../TermsOfService';
import styles from './SignUpModal.module.scss';

// Desktop: https://www.figma.com/file/gZaqAej8HzoFkyrjlQ4cNs/Integrating-Brand-Changes?node-id=6514%3A99348
// Mobile: https://www.figma.com/file/gZaqAej8HzoFkyrjlQ4cNs/Integrating-Brand-Changes?node-id=6514%3A99372

type RegisterProps = {
  heading?: ReactNode;
  logInPrompt?: ReactNode;
  onSuccess: ({ user }: LoginResponse) => void;
  grantType?: string | null;
  prefillEmail?: string;
  onEmailAlreadyExists?: (email: string) => void;
};

const Register = ({ heading, logInPrompt, onSuccess, grantType, prefillEmail, onEmailAlreadyExists }: RegisterProps) => {
  const ariaLabelledBy = useContext(ModalAriaLabelledByContext);
  const defaultHeading = prefillEmail ? (
    <FormattedMessage defaultMessage="Create a free account" />
  ) : (
    <FormattedMessage defaultMessage="To keep exploring trails, log in or sign up for free" />
  );

  return (
    <div className={styles.content}>
      <div className={styles.logo}>
        <Logo variant="symbol" size="lg" color="monochrome-dark" />
      </div>
      <Heading as="h4" id={ariaLabelledBy} size="400" className={styles.header}>
        {heading || defaultHeading}
      </Heading>
      <div className={styles.form}>
        <RegisterForm
          autoFocus
          handleRegistrationSuccess={onSuccess}
          grantType={grantType}
          prefillEmail={prefillEmail}
          onEmailAlreadyExists={onEmailAlreadyExists}
        />
      </div>
      {logInPrompt}
      <TermsOfService />
    </div>
  );
};

export default Register;
